import { apiNames, get, post, patch, put } from '@general/api/shared';

export const fetchCountries = () => get(apiNames.MEMBERSHIP, 'countries');
export const fetchStates = () => get(apiNames.MEMBERSHIP, 'states');
